import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    Configuration,
    ApiModule,
    ConfigurationParameters,
} from '@control-tower/platform-orders';
import { sharedEnv } from '@pf/shared-common';
import { PurchaseOrderHeaderFacade } from './application/purchase-order-header.facade';
import { PurchaseOrderHeaderDataService } from './infrastructure/purchase-order-headers/purchase-order-header.data.service';
import { PurchaseOrderHeaderStore } from './infrastructure/purchase-order-headers/purchase-order-header.store';
import { PurchaseOrderHeaderMapper } from './infrastructure/purchase-order-headers/purchase-order-header.mapper';
import { PurchaseOrderLineFacade } from './application/purchase-order-line.facade';
import { PurchaseOrderLineDataService } from './infrastructure/purchase-order-lines/purchase-order-line.data.service';
import { PurchaseOrderLineStore } from './infrastructure/purchase-order-lines/purchase-order-line.store';
import { PurchaseOrderLineMapper } from './infrastructure/purchase-order-lines/purchase-order-line.mapper';

const apiConfigFactory = (basePath: string) => {
    return (): Configuration => {
        const params: ConfigurationParameters = {
            basePath,
        };
        return new Configuration(params);
    };
};

@NgModule({
    imports: [CommonModule],
    providers: [
        PurchaseOrderHeaderFacade,
        PurchaseOrderHeaderDataService,
        PurchaseOrderHeaderStore,
        PurchaseOrderHeaderMapper,
        PurchaseOrderLineFacade,
        PurchaseOrderLineDataService,
        PurchaseOrderLineStore,
        PurchaseOrderLineMapper,
    ],
})
export class PlatformOrdersDomainModule {
    static ApiModule() {
        return ApiModule.forRoot(
            apiConfigFactory(sharedEnv.baseApiUrl + '/orders')
        );
    }

    static ConfigProviders() {
        return [];
    }
}
